import React from "react";
import { useModal } from "../../../../../../contexts/modalContext/modalContext.js";
import { useUser } from "../../../../../../contexts/userContext/userContext.js";
import Button from "../../../../..//Elements/Button/Button.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import config from "config";
import ToastHtmlComponent from "../../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";

const DeleteProfilePictureModal = () => {
  const { closeModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();
  const { deleteProfilePicture } = useUser();

  const deleteProfilePictureFunction = async () => {
    const response = await deleteProfilePicture();
    if (response.status === "success") {
      if (response.data === 0) {
        addToast(getTextByKey("profileuserdetails-remove-confirmation"), {
          appearance: "success",
        });
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", response.data);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
      }
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 999);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
    closeModal();
  };

  return (
    <div className="recover-password-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <p>{getTextByKey("profileuserdetails-remove-picture")}</p>
            </div>
            <div className="actions">
              <Button
                buttonClass="recover-cancel-button"
                blank
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("profileuserdetails-remove-cancel")}
              </Button>
              <Button
                buttonClass="recover-link-button"
                onClick={() => {
                  deleteProfilePictureFunction();
                }}
              >
                {getTextByKey("profileuserdetails-remove-ok")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default DeleteProfilePictureModal;
